import { useQueryParams } from '@/hooks/shared/use-query-params';
import { useOrdersSuspense } from '../api/list-orders';
import { OrderPanel } from '../components/order-panel';
import { Loader } from '@/shared/components/ui/loader';
import { Flyout } from '@/shared/components/flyout';
import { ErrorFrame } from '@/shared/components/error-frame';
import { OrderList } from '../components/order-list';
import { orderToListItem } from '../utils/order-items';
import { Card } from '@/shared/components/ui/card';

const ORDER_ID_KEY = 'id';

export function Orders() {
  const { data: orders } = useOrdersSuspense({});
  const { getQueryParamByKey, removeQueryParamByKey, setQueryParam } = useQueryParams();
  const orderId = getQueryParamByKey(ORDER_ID_KEY);

  const handleFlyoutOpen = (open: boolean) => {
    if (!open) removeQueryParamByKey(ORDER_ID_KEY);
  };

  return (
    <>
      <div className="sm:flex sm:justify-between sm:items-center mb-5">
        <div className="mb-4 sm:mb-0">
          <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Beställningar</h1>
        </div>
      </div>

      <Card className="p-0">
        <OrderList items={orders.map(orderToListItem)} onRowClick={(orderId) => setQueryParam(ORDER_ID_KEY, orderId)} />
      </Card>

      <Flyout open={Boolean(orderId)} setOpen={handleFlyoutOpen}>
        <ErrorFrame pendingFallback={<Loader absolute />}>{orderId && <OrderPanel orderId={orderId} />}</ErrorFrame>
      </Flyout>
    </>
  );
}
